import Assets from './Assets';
import Localization from './Localization';
import SubscriptionArticles from './Subscription';

export class SubscriptionCategory {
	// _id?: string;
	id: string;
	name: Localization;
	description?: Localization;
	image?: Assets;

	venues: string[];
	subscriptions: SubscriptionArticles[];
}
